import { QRYoutube } from "./qr-youtube";

export { QRYoutube };
